export const getDescription = (data: string | string[], size = 160): string => {
  let text = data;
  if (Array.isArray(text)) {
    text = text.join(' ');
  }
  text = text.replace(/[\b\n]/g, '');

  return text.length < size ? text : text.slice(0, size) + '...';
};
